import React from 'react';
const MainOwnerPage = () => {
    return <div>statistics</div>;
};

export default MainOwnerPage;
